import { CommonUtilities } from '../../commonUtils';

export default class WizardServices {

    static contactInfo(ContactCode: any) {
        var url = 'contacts/info/' + ContactCode;
        return CommonUtilities.getData(url);
    }

    static contactTag(Contact: any) {
        var url = 'contract/tag/list?' + CommonUtilities.buildQueryString(Contact, true, true);
        return CommonUtilities.getData(url);
    }

    static contactTagSave(Contact: any) {
        var url = 'contract/tag/save';
        return CommonUtilities.putData(url, Contact);
    }

    static contactClassification(Contact: any) {
        var url = 'musicDirectory/musicDirectoryCategory/list?' + CommonUtilities.buildQueryString(Contact, true, true);
        return CommonUtilities.getData(url);
    }

    static zFreeTextList(Contact: any) {
        var url = 'zFreeText/classification';
        return CommonUtilities.postData(url, Contact);
    }

    static zFreeTextSave(Contact: any) {
        var url = 'zFreeText/save';
        return CommonUtilities.postData(url, Contact);
    }

    static contactsdetails(Contact: any) {
        var url = 'contacts/' + Contact + '/details';
        return CommonUtilities.getData(url);
    }

    static kontacts_IPIdetails(Contact: any) {
        var url = 'contract/kontacts_IPI/list?' + CommonUtilities.buildQueryString(Contact, true, true);
        return CommonUtilities.getData(url);
    }

    static RecipientDelete(Contact: any, id: any) {
        var url = 'contacts/' + Contact + '/details/' + id;
        return CommonUtilities.deleteData(url);
    }

    static RecipientSave(Contact: any, data: any) {
        var url = 'contacts/' + Contact + '/details';
        return CommonUtilities.postData(url, data);
    }
    /*
        company: "Google"
        contactEmail: "test@example.us"
        contactFirst: "Jon"
        contactLast: "Doe"
        kontactCode: "PR00007367"
        statementCategory: "10"
        telephone: "6019521325"
        telephone2: "3121286800"
    */

    static SocietiesDelete(id: any) {
        var url = 'kontacts_IPI/delete/' + id;
        return CommonUtilities.deleteData(url);
    }

    static SocietiesSave(data: any) {
        var url = 'contract/kontacts_IPI/save';
        return CommonUtilities.postData(url, data);
    }


    static listCompanyInfo(Contact: any) {
        var url = 'Contract/kontactCompanyInfo/listCompanyInfo?' + CommonUtilities.buildQueryString(Contact, true, true);
        return CommonUtilities.getData(url);
    }

    static kontactSave(data: any, file: any) {
        var url = 'contacts/info';
        return CommonUtilities.postUploadFile(url, file, data);
    }

    static contractscontractRefNum(Contact: any) {
        var url = 'contracts/' + Contact;
        return CommonUtilities.getData(url);
    }

    static contractsratesBasis(Contact: any) {
        var url = 'contracts/' + Contact + '/ratesBasis';
        return CommonUtilities.getData(url);
    }

    static contractsratesBasisDelete(Contact: any, id: any) {
        var url = 'contracts/' + Contact + '/ratesBasis/' + id;
        return CommonUtilities.deleteData(url);
    }


    static contractssystemUses(Contact: any) {
        var url = 'contracts/systemUses/';
        return CommonUtilities.getData(url);
    }

    static contractssystemFormats(Contact: any) {
        var url = 'contracts/systemFormats?' + CommonUtilities.buildQueryString(Contact, true, true);
        return CommonUtilities.getData(url);
    }

    static contractssystemsystemRegions(Contact: any) {
        var url = 'contracts/systemRegions/' + Contact;
        return CommonUtilities.getData(url);
    }

    static systemTerritoryCode(Contact: any) {
        var url = 'contracts/systemTerritoryCode?' + CommonUtilities.buildQueryString(Contact, true, true);
        return CommonUtilities.getData(url);
    }

    static deletesystemTerritory(param: any) {
        var url = 'contracts/systemTerritory/';
        return CommonUtilities.putData(url, param)
    }

    static updateContractRegion(param: any) {
        var url = 'contracts/updateContractRegion/';
        return CommonUtilities.putData(url, param)
    }

    static TerritorySave(param: any) {
        var url = 'contracts/territoryCodes';
        return CommonUtilities.postData(url, param)
    }

    static clearTerritoriesInRegion(param: any) {
        var url = 'contracts/clearTerritoriesInRegion/';
        return CommonUtilities.postData(url, param)
    }


    static saveDefaultRegion(Contact: any) {
        var url = 'contracts/zones/saveDefaultRegion?' + CommonUtilities.buildQueryString(Contact, true, true);
        return CommonUtilities.getData(url);
    }


    static regionterritoriesSave(Contract: any) {
        var url = 'contracts/regionterritories/';
        return CommonUtilities.postData(url, Contract)
    }

    static contractsanalysisCodes() {
        var url = 'contracts/analysisCodes/';
        return CommonUtilities.getData(url);
    }

    static ContractRateSave(Contact: any, data: any) {
        var url = 'contracts/' + Contact + '/ratesBasis';
        return CommonUtilities.postData(url, data);
    }

    static contractRoyaltiesListing(Contact: any) {
        var url = 'contracts/' + Contact + '/allowableCostLinks';
        return CommonUtilities.getData(url);
    }

    static contractRoyaltiesDelete(Contact: any, data: any) {
        var url = 'contracts/' + Contact + '/allowableCostLinks/' + data;
        return CommonUtilities.deleteData(url);
    }

    static contractRoyaltiesSave(Contact: any, data: any) {
        var url = 'contracts/' + Contact + '/allowableCostLink';
        return CommonUtilities.postData(url, data);
    }

    static contractReserveListing(Contact: any) {
        var url = 'contracts/' + Contact + '/reserves';
        return CommonUtilities.getData(url);
    }

    static contractReserveSave(Contact: any, data: any) {
        var url = 'contracts/' + Contact + '/reserves';
        return CommonUtilities.postData(url, data);
    }

    static contractReserveDelete(Contact: any, id: any) {
        var url = 'contracts/' + Contact + '/reserves/' + id;
        return CommonUtilities.deleteData(url);
    }

    static contractAdjustmentType() {
        var url = 'contracts/adjustmentType';
        return CommonUtilities.getData(url);
    }

    static mainContractsSave(contract: any, data: any) {
        var url = 'contracts/' + contract + '/mainContracts';
        return CommonUtilities.postData(url, data);
    }

    static mainContractsDelete(data: any, id: any) {
        var url = 'contracts/' + data?.contractRefNum + '/mainContracts/' + id;
        return CommonUtilities.deleteData(url);
    }

    static getThirdPartyContractsListing(contract: any) {
        var url = 'contracts/' + contract + '/getThirdPartyContracts';
        return CommonUtilities.getData(url);
    }

    static getThirdPartyContractSave(contract: any, data: any) {
        var url = 'contracts/' + contract + '/thirdPartyContracts';
        return CommonUtilities.postData(url, data);
    }

    static getThirdPartyContractDelete(contract: any, id: any) {
        var url = 'contracts/' + contract + '/thirdPartyContracts/' + id;
        return CommonUtilities.deleteData(url);
    }


    static contractDocument(Contact: any) {
        var url = 'contract/contractDocument/list?' + CommonUtilities.buildQueryString(Contact, true, true);
        return CommonUtilities.getData(url);
    }

    static contractAdjustmentListing(Contact: any) {
        var url = 'contracts/' + Contact + '/adjustments';
        return CommonUtilities.getData(url);
    }

    static contractAdjustmentSave(Contact: any, data: any) {
        var url = 'contracts/' + Contact + '/adjustments';
        return CommonUtilities.postData(url, data);
    }

    static contractAdjustmentDelete(Contact: any, data: any) {
        var url = 'contracts/' + Contact + '/adjustments/' + data;
        return CommonUtilities.deleteData(url);
    }
}